import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import SetUpAuctionforMobile from './timedAuction/commonLayout/setUpAuctionforMobile'
import SaveDraftModal from './saveDraftModal';
import Banner from '../../../components/layout/notificationbannar';
import { dataService } from '../../../services/dataService';
import SetUpLiveAuctionforMobile from './liveAuction/commonLayout/setUpAuctionforMobile';
import ErrorMessage from '../../../CommonComponent/errorMessage';

export default function AuctionHeader({ auctionData, setAuctionData, setEditedAuctionData, handleLogoChange,
    handleLogoRedirectionChange, handleLogoDelete, errorMessages, deleteMenuLink,
    addDropdownLink, deleteDropdownLink, setNewMenuLink, isAddingDropdown, setIsAddingDropdown,
    setMenuModal, startDate, setStartDate, endDate, setEndDate, setEditMenu,
    startHour, setStartHour, startMin, setStartMin, isBanner, setIsBanner,
    endHour, setEndHour, endMin, setEndMin, mobileModal, isMobileModal,
    saveDraftModal, setSaveDraftModal, handleCreateAuction, loader, onSetupSectionChange,
    menuLinkError, logoLoader, setLogoLoader, imageLoader, setImageLoader, setInvalidDate, setSameTime, invalidDate,
    sameTime, startDateBeforeCurrent, setStartDateBeforeCurrent, edit }) {

    // Provide default no-op function if setStartDateBeforeCurrent is not provided
    const safeSetStartDateBeforeCurrent = setStartDateBeforeCurrent || (() => { });

    const [isOpen, setIsOpen] = useState(true)
    const path = useLocation();
    const [disableSave, setDisableSave] = useState(false)
    const [text, setText] = useState("");
    const navigate = useNavigate();
    const { template } = useParams();

    const [notes, setNotes] = useState({});
    const [istextShow, setIstextShow] = useState(false);

    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    const numberOfChars = () => {
        if (screenWidth > 1130) {
            return 200
        } else if (screenWidth > 1102) {
            return 130
        } else if (screenWidth > 774) {
            return 60
        } else if (screenWidth > 418) {
            return 50;
        } else {
            return 20;
        }
    }

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = notes?.notification;


    const allPs = tempDiv.querySelectorAll('p');  // Get all <p> tags
    const firstP = allPs[0];  // Get the first <p> tag
    const secondPExists = allPs.length > 1;

    const displayContent = notes?.notification?.length > numberOfChars() || secondPExists;
    const notificationContent = istextShow ? notes?.notification : firstP?.outerHTML.substring(0, numberOfChars() - 6);
    const buttonText = istextShow ? 'Read less' : 'Read more';


    const handleResize = () => {
        setScreenWidth(window.innerWidth);
    };

    // Attach event listener when the component renders
    window.addEventListener('resize', handleResize)

    const viewBanner = async () => {
        const response = await dataService.BannerNotification();
        if (response.error === false) {
            setNotes(response.data.data);
            setIsBanner(false)
        }
        else {
            setIsBanner(true)
        }
    }

    const toggleFullText = () => {
        setIstextShow(!istextShow);
    }

    useEffect(() => {
        viewBanner()
    }, [])

    useEffect(() => {
        if (auctionData !== undefined && Object.keys(auctionData).length > 0) {
            setText(auctionData.description);
        }
    },[auctionData && Object.keys(auctionData).length])

    const hasVoluntaryContributionPercentageError = () => {
        if (auctionData?.add_buyer_fees !== 'Voluntary contribution (buyer chooses)') {
            return false;
        }

        const percentageOptions = Array.isArray(auctionData?.buyer_fee_details?.percentage_options)
            ? auctionData.buyer_fee_details.percentage_options
            : [];

        return percentageOptions.some((option, optionIndex) => {
            const value = option?.value || '';
            const isRecommended = !!option?.is_recommended;
            const isDuplicate = value !== '' && percentageOptions.some((currentOption, currentIndex) => {
                if (currentIndex === optionIndex) {
                    return false;
                }

                return (currentOption?.value || '') === value && (currentOption?.value || '') !== '';
            });

            return (value === '' && isRecommended) || isDuplicate;
        });
    }
    
    useEffect(()=>{
        if(menuLinkError!==undefined){
            if(errorMessages?.logoError!=='' || (auctionData?.make_your_auction_private==true && auctionData?.passcode=="") 
            || errorMessages?.logoRedirectionUrlError!=='' 
        || errorMessages?.auction_image_error!=='' || menuLinkError?.title || menuLinkError?.url || invalidDate || sameTime 
        || startDateBeforeCurrent || Number(auctionData?.extension_time_between_lots) > 60 
        || Number(auctionData?.extension_time) >1440
        || hasVoluntaryContributionPercentageError()){
                setDisableSave(true)
            }
            else {
                setDisableSave(false)
            }
        }
    }, [errorMessages, auctionData, invalidDate, sameTime, startDateBeforeCurrent, menuLinkError])

    return (
        <>
            <Banner viewBanner={viewBanner} notes={notes} setNotes={setNotes} toggleFullText={toggleFullText}
                displayContent={displayContent} notificationContent={notificationContent} buttonText={buttonText}
                istextShow={istextShow} />

            <nav className={`h-[68px] md:px-10 px-5 flex border-b border-[#D4D4D8] justify-between overflow-x-hidden 
            sticky  ${isBanner ? 'top-0': 'top-[45px] z-[999]'} z-[101] bg-[#FFFFFF]`}>
                <Link 
                    onClick={()=>navigate(-1)}
                    className="flex items-center">
                    <img src="/images/arrow-left-dark.svg" alt="img" className="cursor-pointer" loading="lazy" />
                    <p className="md:block hidden pl-5 py-5">Auction creator</p>
                </Link>
                {((template && path.pathname.includes(`/create/${template}`)) || path.pathname.includes(`/edit`)) &&
                    <div className='flex justify-end items-center'>
                        <button id="preview-btn" onClick={() => setIsOpen((prevState) => !prevState)}
                            className={`md:hidden block border border-[#282828] rounded-md text-[14px] text-[#282828] 
                leading-normal font-medium px-[20px] py-[12px] ${isOpen ? "w-[110px]" : "w-[165px]"} 
                md:w-[135px] bg-[#FFFFFF] mr-2`}>
                            {!isOpen ? "Continue Editing" : "Preview"}</button>
                        <button id="save-btn" onClick={() => setSaveDraftModal(true)}
                            disabled={((auctionData?.status == "Published" || auctionData?.status == "Accepting bids") &&
                                (auctionData?.title == "" || auctionData?.auction_image == ""
                                    || auctionData?.description == "")) || disableSave}
                            className=" bg-[#282828] rounded-md text-[14px] text-[#fff] hover:bg-[#626465]
                leading-normal font-medium px-[20px] py-[12px] w-[110px] md:w-[135px] disabled:bg-[#A1A1A9]"
                        >Save</button>
                    </div>}
            </nav>

            {auctionData!==undefined && menuLinkError!==undefined && logoLoader!==undefined && setLogoLoader!==undefined &&
            imageLoader!==undefined && setImageLoader!==undefined &&
            <>
                {path.pathname.includes("timed") ? <SetUpAuctionforMobile setIsOpen={setIsOpen} 
                    isOpen={isOpen} auctionData={auctionData} 
                    text={text} setText={setText}
                    setEditedAuctionData={setEditedAuctionData}
                    setAuctionData={setAuctionData}
                    handleLogoChange={handleLogoChange}
                    handleLogoRedirectionChange={handleLogoRedirectionChange}
                    handleLogoDelete={handleLogoDelete}
                    errorMessages={errorMessages}
                    deleteMenuLink={deleteMenuLink}
                    addDropdownLink={addDropdownLink}
                    deleteDropdownLink={deleteDropdownLink}
                    setNewMenuLink={setNewMenuLink}
                    isAddingDropdown={isAddingDropdown} 
                    setIsAddingDropdown={setIsAddingDropdown}
                    setMenuModal={setMenuModal}
                    startDate={startDate} 
                    setStartDate={setStartDate}
                    endDate={endDate} 
                    setEndDate={setEndDate}
                    startHour={startHour}
                    setStartHour={setStartHour}
                    startMin={startMin}
                    setStartMin={setStartMin}
                    endHour={endHour}
                    setEndHour={setEndHour}
                    endMin={endMin}
                    setEndMin={setEndMin}
                    logoLoader={logoLoader}
                    setLogoLoader={setLogoLoader}
                    imageLoader={imageLoader}
                    setImageLoader={setImageLoader}
                    setInvalidDate={setInvalidDate}
                    setSameTime={setSameTime}
                    setStartDateBeforeCurrent={safeSetStartDateBeforeCurrent}
                    mobileModal ={mobileModal}
                    isMobileModal={isMobileModal}
                    setEditMenu={setEditMenu}
                    isBanner={isBanner} edit={edit}
                    onSetupSectionChange={onSetupSectionChange}
                /> : <SetUpLiveAuctionforMobile setIsOpen={setIsOpen} isOpen={isOpen} auctionData={auctionData} 
                    text={text} setText={setText}
                    setEditedAuctionData={setEditedAuctionData}
                    setAuctionData={setAuctionData}
                    handleLogoChange={handleLogoChange}
                    handleLogoRedirectionChange={handleLogoRedirectionChange}
                    handleLogoDelete={handleLogoDelete}
                    errorMessages={errorMessages}
                    deleteMenuLink={deleteMenuLink}
                    addDropdownLink={addDropdownLink}
                    deleteDropdownLink={deleteDropdownLink}
                    setNewMenuLink={setNewMenuLink}
                    isAddingDropdown={isAddingDropdown} 
                    setIsAddingDropdown={setIsAddingDropdown}
                    setMenuModal={setMenuModal}
                    startDate={startDate} 
                    setStartDate={setStartDate}
                    startHour={startHour}
                    setStartHour={setStartHour}
                    startMin={startMin}
                    setStartMin={setStartMin}
                    logoLoader={logoLoader}
                    setLogoLoader={setLogoLoader}
                    imageLoader={imageLoader}
                    setImageLoader={setImageLoader}
                    mobileModal ={mobileModal}
                    isMobileModal={isMobileModal}
                    setEditMenu={setEditMenu}
                    isBanner={isBanner} edit={edit}
                    startDateBeforeCurrent={startDateBeforeCurrent}
                    setStartDateBeforeCurrent={safeSetStartDateBeforeCurrent}
                />}
                <SaveDraftModal saveDraftModal={saveDraftModal}
                    setSaveDraftModal={setSaveDraftModal} auctionData={auctionData}
                    handleCreateAuction={handleCreateAuction}
                    loader={loader}/>
            </>
            }
        </>
    )
}
